import Voice from '@react-native-voice/voice';
import {check, request, PERMISSIONS, RESULTS} from 'react-native-permissions';
import {isIOS} from './PlatformCheck';

const DELAY_TIME = 8;

class VoiceHelper {
  timer: any = undefined;
  counter: any = 0;
  constructor(
    onSpeechStart: () => void,
    onSpeechRecognized: () => void,
    onSpeechEnd: () => void,
    onSpeechError: (error: any) => void,
    onSpeechResults: (result: any) => void,
    onSpeechPartialResults: (result: any) => void,
    onSpeechVolumeChanged: (volume: any) => void,
  ) {
    Voice.onSpeechStart = onSpeechStart;
    Voice.onSpeechRecognized = onSpeechRecognized;
    Voice.onSpeechEnd = onSpeechEnd;
    Voice.onSpeechError = onSpeechError;
    Voice.onSpeechResults = onSpeechResults;
    Voice.onSpeechPartialResults = onSpeechPartialResults;
    Voice.onSpeechVolumeChanged = onSpeechVolumeChanged;

    this.timer = undefined;
    this.counter = 0;
  }

  setTimer = () => {
    this.timer = setInterval(() => {
      // console.log('this.counter ----->:', this.counter);
      if (this.counter >= DELAY_TIME) {
        this.stopRecognizing();
        clearInterval(this.timer);
        this.timer = undefined;
      }
      this.counter++;
    }, 500);
  };

  async requestMicrophonePermission(): Promise<boolean> {
    const permission = isIOS
      ? PERMISSIONS.IOS.MICROPHONE
      : PERMISSIONS.ANDROID.RECORD_AUDIO;

    try {
      const result = await check(permission);
      if (result === RESULTS.GRANTED) {
        return true;
      } else {
        const requestResult = await request(permission);
        return requestResult === RESULTS.GRANTED;
      }
    } catch (error) {
      console.error('Error requesting microphone permission', error);
      return false;
    }
  }

  resetCounter = () => {
    this.counter = 0;
  };

  startRecognizing = async () => {
    const hasPermission = await this.requestMicrophonePermission();
    if (!hasPermission) {
      console.error('Microphone permission denied');
      return;
    }

    try {
      await Voice.isAvailable();
      await Voice.start('en-US', {
        EXTRA_SPEECH_INPUT_POSSIBLY_COMPLETE_SILENCE_LENGTH_MILLIS: 3000,
        // speechRecognitionPermission: true,
      });
      if (isIOS) {
        if (!this.timer) {
          this.setTimer();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  stopRecognizing = async () => {
    try {
      await Voice.stop();
    } catch (e) {
      console.error(e);
    }
  };

  cancelRecognizing = async () => {
    try {
      await Voice.cancel();
    } catch (e) {
      console.error(e);
    }
  };

  destroyRecognizer = async () => {
    try {
      await Voice.destroy();
    } catch (e) {
      console.error(e);
    }
    Voice.removeAllListeners();
  };
}

export default VoiceHelper;
